function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import intersection from 'lodash/intersection';
import { useAction } from 'hooks';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';
import Switch from 'components/Form/Switch';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import messages from '../../../messages';
import validatorRules from './validatorRules.json';
const Field = ({ id, formValues, options, isDisabled = false, onSetFormValue })=>/*#__PURE__*/ _jsx("div", {
        className: "col-6 mb-5",
        children: /*#__PURE__*/ _jsx(FormGroup, {
            id: id,
            labelMessage: Account.messages.labels[id] || App.messages.labels[id],
            formValues: formValues,
            children: options ? /*#__PURE__*/ _jsx(Select, {
                optionsFrom: options,
                valueKey: "value",
                labelKey: "label",
                isDisabled: isDisabled,
                onChange: onSetFormValue
            }) : /*#__PURE__*/ _jsx(Input, {
                onChange: onSetFormValue
            })
        })
    });
const Actions = ({ isInProgress, onClose })=>/*#__PURE__*/ _jsxs("div", {
        className: "row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.cancel,
                    className: "btn--block",
                    isDisabled: isInProgress,
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "submit",
                    styleModifier: "primary",
                    className: "btn--block btn--filled",
                    labelMessage: App.messages.buttons.submit,
                    isInProgress: isInProgress
                })
            })
        ]
    });
const CreateInvitationForm = ({ adminOrganizationMembership, isInProgress, onClose })=>{
    const formName = constants.CREATE_INVITATION_FORM;
    const scopesRef = useRef([]);
    const countries = useSelector(App.selectors.countries);
    const formValues = useSelector(App.selectors.formSelector(formName));
    const createInvitation = useAction(actions.createInvitation);
    const onSetFormValue = useAction(App.actions.setFormValue, formName);
    const setFormValues = useAction(App.actions.setFormValues, formName);
    const clearForm = useAction(App.actions.clearForm, formName);
    useEffect(()=>{
        const { organization } = adminOrganizationMembership;
        const country = countries.find((c)=>c.alpha2Code === organization.countryCode);
        const availableScopes = get(country, 'availableScopes', []);
        scopesRef.current = intersection(Account.constants.BUSINESS_SCOPES, availableScopes);
        if (scopesRef.current.length === 1) {
            setFormValues({
                scope: scopesRef.current[0]
            });
        }
        return ()=>{
            clearForm();
        };
    }, []);
    const scopes = scopesRef.current;
    const scopeOptions = scopes.map((scopeName)=>({
            value: scopeName,
            label: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Account.messages.scopes[scopeName]))
        }));
    const submitForm = useCallback((validatedValues)=>{
        createInvitation(validatedValues, adminOrganizationMembership);
    }, [
        adminOrganizationMembership
    ]);
    const processForm = App.hooks.useFormProcessing(formName, submitForm);
    const onSubmit = ()=>processForm(formValues, validatorRules);
    return /*#__PURE__*/ _jsxs(Form, {
        className: "form",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx(Field, {
                        id: "firstName",
                        formValues: formValues,
                        onSetFormValue: onSetFormValue
                    }),
                    /*#__PURE__*/ _jsx(Field, {
                        id: "lastName",
                        formValues: formValues,
                        onSetFormValue: onSetFormValue
                    }),
                    /*#__PURE__*/ _jsx(Field, {
                        id: "businessEmail",
                        formValues: formValues,
                        onSetFormValue: onSetFormValue
                    }),
                    /*#__PURE__*/ _jsx(Field, {
                        id: "scope",
                        formValues: formValues,
                        options: scopeOptions,
                        isDisabled: scopes.length === 1,
                        onSetFormValue: onSetFormValue
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto mb-5",
                        children: /*#__PURE__*/ _jsx(Switch, {
                            id: "isAdmin",
                            inputValue: "true",
                            labelMessage: messages.labels.isAdmin,
                            formValues: formValues,
                            onChange: onSetFormValue
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Actions, {
                isInProgress: isInProgress,
                onClose: onClose
            })
        ]
    });
};
export default CreateInvitationForm;
